module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AppToolbar"
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleSideNav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" Rodeostat Web App V1.2.1")]), _vm._v(" "), _c('h1', {
    staticClass: "md-subheading",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v(" IO Rodeo ")])], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "sideNav",
    staticClass: "md-left",
    on: {
      "open": _vm.sideNavOpen,
      "close": _vm.sideNavClose
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Select Option ")])])]), _vm._v(" "), _c('div', [_c('md-list', [_c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('DeviceConnection')
      }
    }
  }, [_vm._v(" Device Connection ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('TestAndParameters')
      }
    }
  }, [_vm._v(" Test & Parameters ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('CollectData')
      }
    }
  }, [_vm._v(" Data Acquisition ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-523106dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppToolbar.vue
// module id = 164
// module chunks = 1